/**
 * Konum koordinatları (ürün turu 08.10.2026: aralık dışı değerde ileti hangi koordinatın hatalı olduğunu söylemiyordu —
 * "Konum: en çok 90"). Kişi/şirket konumu, aktivite konumu ve konum tipi özel alan aynı şemayı kullanır.
 */
import { z } from 'zod';
const LAT = 'enlem -90 ile 90 arasında olmalı';
const LNG = 'boylam -180 ile 180 arasında olmalı';
export const latitudeSchema = z.number().min(-90, LAT).max(90, LAT);
export const longitudeSchema = z.number().min(-180, LNG).max(180, LNG);
//# sourceMappingURL=geo.js.map